import { ScopeOption } from '../types';

/**
 * Варианты скоупов для модуля «Электронный журнал» (journal.*)
 */
export const journalScopes: Record<string, ScopeOption[]> = {
  // Просмотр записей журнала
  'journal.view': [
    {
      value: 'all',
      label: 'Все записи сети',
      description: 'Полный кассовый и операционный журнал',
      badgeColor: '#10b981'
    },
    {
      value: 'assigned_pharmacies',
      label: 'Только свои аптеки',
      description: 'Записи привязанных аптек',
      badgeColor: '#3b82f6'
    }
  ],

  // Аналитика журнала (графики, «Товар», «Без записей»): зона может быть уже зоны таблицы
  'journal.analytics.view': [
    {
      value: 'all',
      label: 'Вся сеть',
      description: 'Аналитика по всем аптекам сети',
      badgeColor: '#10b981'
    },
    {
      value: 'assigned_pharmacies',
      label: 'Только свои аптеки',
      description: 'Аналитика по привязанным аптекам',
      badgeColor: '#3b82f6'
    }
  ]
};
